import script from "./DefaultHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefaultHeader.vue?vue&type=script&setup=true&lang=ts"

import "./DefaultHeader.vue?vue&type=style&index=0&id=411fda48&lang=scss"

const __exports__ = script;

export default __exports__